import { createContext } from 'react';
export default createContext({
  viewport: null,
  map: null,
  mapContainer: null,
  onViewportChange: null,
  onViewStateChange: null,
  eventManager: null,
  isDragging: false
});
//# sourceMappingURL=map-context.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-map-gl/dist/esm/components/map-context.js
// module id = 122
// module chunks = 66